import ApiService from 'utils/ApiCalls';
import axios from 'axios';
import { notification } from 'antd';

const fetchTPPbyEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postTPPbyEntityName(entityTypeData);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error fetching TPP:', error.response?.data || error.message);
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

const setNonSubstReason = async () => {
  try {
    const response = await ApiService.getNonSubstReason();
    return response;
  } catch (error) {
    console.log('Error setting the Value of Non Subst Reason:', error);
  }
};

const fetchNonSubstReason = async (tpp_name: string, tpp_id: string) => {
  try {
    const response = await ApiService.fetchNonSubstReason(tpp_name, tpp_id);
    if (response.data) {
      return response.data;
    } else {
      console.log('Unexpected response structure:', response);
    }
  } catch (error) {
    console.log('Error fetching the Value of Non Subst Reason:', error);
  }
};

const setPersonType = async (tpp_name: string, tpp_id: string) => {
  try {
    const response = await ApiService.fetchPersonType(tpp_name, tpp_id);
    if (response.data) {
      return response.data;
    } else {
      console.log('Unexpected response structure:', response);
    }
  } catch (error) {
    console.log('Error fetching the Value of Person Type:', error);
  }
};

const setCurrencyAndCosts = async (tpp_name: string, tpp_id: string) => {
  try {
    const response = await ApiService.fetchCurrencyAndCosts(tpp_name, tpp_id);
    if (response.data) {
      return response.data;
    } else {
      console.log('Unexpected response structure:', response);
    }
  } catch (error) {
    console.log('Error fetching the Currency and Costs:', error);
  }
};

const setCertificates = async (tpp_name: string, tpp_id: string) => {
  try {
    const response = await ApiService.fetchCertificates(tpp_name, tpp_id);
    if (response.data) {
      return response.data;
    } else {
      console.log('Unexpected response structure:', response);
    }
  } catch (error) {
    console.log('Error fetching the Value of Certificates:', error);
  }
};

const fetchTPP = async (tpp: any) => {
  try {
    const response = await ApiService.postTPP(tpp);
    notification.success({
      message: 'Info',
      description:
        'The ICT third-party service provider has been successfully saved.',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const insertNonSubstReason = async (nonSubstReason: any) => {
  try {
    const response = await ApiService.postNonSubstReason(nonSubstReason);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching NonSubstReason:',
        error.response?.data || error.message,
      );
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

const insertPersonTypes = async (personTypes: any) => {
  try {
    const response = await ApiService.postPersonTypes(personTypes);
    notification.success({
      message: 'Info',
      description: 'Person types - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching person types:',
        error.response?.data || error.message,
      );
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

const insertCurrencyAndCosts = async (currencyAndCosts: any) => {
  try {
    const response = await ApiService.postCurrencyAndCosts(currencyAndCosts);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching Currency and Costs:',
        error.response?.data || error.message,
      );
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

const insertCertificates = async (certificates: any) => {
  try {
    const response = await ApiService.postCertificates(certificates);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching Certificates:',
        error.response?.data || error.message,
      );
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

const fetchValues = async () => {
  try {
    const response = await ApiService.getValueOfTotalAssets();
    return response;
  } catch (error) {
    console.log('Error fetching values api:', error);
  }
};

const fetchNonSubstReasons = async () => {
  try {
    const response = await ApiService.getNonSubstReasons();
    return response;
  } catch (error) {
    console.log('Error fetching non subst reasons api:', error);
  }
};

const fetchPersonTypes = async () => {
  try {
    const response = await ApiService.getListPersonTypes();
    return response;
  } catch (error) {
    console.log('Error fetching person types api:', error);
  }
};

const fetchCosts = async () => {
  try {
    const response = await ApiService.getCosts();
    return response;
  } catch (error) {
    console.log('Error fetching costs api:', error);
  }
};

const fetchContractualArrangements = async () => {
  try {
    const response = await ApiService.getContractualArrangements();
    return response;
  } catch (error) {
    console.log('Error fetching contractual arrangements api:', error);
  }
};

const fetchFunctions = async () => {
  try {
    const response = await ApiService.getFunctions();
    return response;
  } catch (error) {
    console.log('Error fetching functions api:', error);
  }
};

const fetchICTServices = async () => {
  try {
    const response = await ApiService.getICTServices();
    return response;
  } catch (error) {
    console.log('Error fetching ict services api:', error);
  }
};

const fetchProviderCodeTypes = async () => {
  try {
    const response = await ApiService.getProviderCodeTypes();
    return response;
  } catch (error) {
    console.log('Error fetching provider code types api:', error);
  }
};

const fetchDoraRegulatorCriticality = async () => {
  try {
    const response = await ApiService.getDoraRegulatorCriticality();
    return response;
  } catch (error) {
    console.log('Error fetching the dora regulator criticality', error);
  }
};

const fetchAllThirdPartyServiceProviders = async () => {
  try {
    const response = await ApiService.getListOfThirdPartyServiceProviders();
    return response;
  } catch (error) {
    console.log('Error fetching third party service providers:', error);
  }
};

const fetchThirdPartyServiceProvidersByEntity = async (entity_id: number) => {
  try {
    const response =
      await ApiService.getListOfThirdPartyServiceProvidersByEntity(entity_id);
    return response;
  } catch (error) {
    console.log(
      'Error fetching third party service providers by entity:',
      error,
    );
  }
};

const inactivateTPP = async (dataList: number[]) => {
  try {
    const response = await ApiService.inactivateTPP(dataList);

    const { errors, deleted_tpps, message } = response.data;

    if (errors && errors.length > 0) {
      errors.forEach((error: { tpp_id: number; error: string }) => {
        notification.error({
          message: `Error for TPP ID: ${error.tpp_id}`,
          description: error.error,
          duration: 10,
        });
      });
    } else if (deleted_tpps && deleted_tpps.length > 0) {
      notification.success({
        message: 'Info',
        description: message,
        duration: 10,
      });
    } else {
      notification.success({
        message: 'Info',
        description: message,
        duration: 10,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'Failed to inactivate tpp. Please try again.',
      duration: 10,
    });

    throw new Error('Failed to inactivate tpp');
  }
};

export default {
  fetchTPPbyEntityName,
  setNonSubstReason,
  fetchNonSubstReason,
  setPersonType,
  setCurrencyAndCosts,
  setCertificates,
  fetchTPP,
  insertNonSubstReason,
  insertPersonTypes,
  insertCurrencyAndCosts,
  insertCertificates,
  fetchValues,
  fetchNonSubstReasons,
  fetchPersonTypes,
  fetchCosts,
  fetchContractualArrangements,
  fetchFunctions,
  fetchICTServices,
  fetchProviderCodeTypes,
  fetchDoraRegulatorCriticality,
  fetchAllThirdPartyServiceProviders,
  fetchThirdPartyServiceProvidersByEntity,
  inactivateTPP,
};
